export default __webpack_public_path__ + "static/media/Snd_LowerWSlideup.f245d8c2.mp3";